export default {
  mutations: {
    SET_NAVBAR_STATE: 'SET_NAVBAR_STATE',
  },
  getters: {
    GET_NAVBAR_STATE: 'GET_NAVBAR_STATE',
  },
};
